import React, { Component } from "react";

import { Row, Col, Button, Popover, Card, Modal } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import {
  InstagramOutlined,
  MailOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/HumanResource/HumanResource.css";

import HumanResourceCard from "./HumanResourceCard.js";

import tmp from "../../../Imgs/AboutUs/HumanResource/Managers/temp.png";
import tmplady from "../../../Imgs/AboutUs/HumanResource/Directors/tmp-lady.png";
import dir1 from "../../../Imgs/AboutUs/HumanResource/Directors/1.jpg";
import dir2 from "../../../Imgs/AboutUs/HumanResource/Directors/2.jpg";
import dir3 from "../../../Imgs/AboutUs/HumanResource/Directors/3.jpg";
import dir4 from "../../../Imgs/AboutUs/HumanResource/Directors/4.jpeg";
import dir5 from "../../../Imgs/AboutUs/HumanResource/Directors/5.jpg";
import dir6 from "../../../Imgs/AboutUs/HumanResource/Directors/6.jpg";
import dir7 from "../../../Imgs/AboutUs/HumanResource/Directors/7.jpeg";
import dir8 from "../../../Imgs/AboutUs/HumanResource/Directors/8.jpg";
import dir9 from "../../../Imgs/AboutUs/HumanResource/Directors/9.jpg";
import dir10 from "../../../Imgs/AboutUs/HumanResource/Directors/10.JPG";
import dir11 from "../../../Imgs/AboutUs/HumanResource/Directors/11.JPG";
import dir12 from "../../../Imgs/AboutUs/HumanResource/Directors/12.JPG";
import dir13 from "../../../Imgs/AboutUs/HumanResource/Directors/13.JPG";
import dir14 from "../../../Imgs/AboutUs/HumanResource/Directors/14.JPG";
import dir15 from "../../../Imgs/AboutUs/HumanResource/Directors/15.jpg";
import dir16 from "../../../Imgs/AboutUs/HumanResource/Directors/16.jpg";

const HeadsTab = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <Margin top={4}></Margin>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={5}>
              <HumanResourceCard
                img={dir5}
                name="مجتبی زیرک جو"
                job="رئیس اداره درامد و وصول"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={dir15}
                name="مرتضی طبیبی"
                job="رئیس اداره زنجیره تأمین"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={dir10}
                name="سعید بیات"
                job="رئیس اداره ارزیابی بازدید اولیه"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
              <HumanResourceCard
                img={dir4}
                name="آرمان عبدالهي"
                job="رئیس اداره دیجیتال واحد اموال "
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={5}>
              <HumanResourceCard
                img={dir7}
                name="نیما امینی"
                job="رئیس اداره امداد خودرو"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={dir16}
                name="مهسا اسماعیل پور"
                job="رئیس اداره نجات"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={dir9}
                name="هلاله رحیم زاده"
                job="رئیس اداره CRM اشخاص"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={dir2}
                name="نازنين حاجي نصرالله"
                job="رئیس اداره آموزش "
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={5}>
          
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={dir12}
                name="آرام عزیزی"
                job="رئیس اداره پشتیبان آنلاین بیمه‌های خودرو"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>

            <Col span={5}>
            <HumanResourceCard
                img={dir14}
                name="اصغر نوری"
                job="رئیس اداره خسارت مالی خودروهای سنگین"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={dir13}
                name="محسن فراهانی"
                job="رئیس اداره خسارت مالی خودروهای سبک"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
   
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Margin top={4}></Margin>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
            <HumanResourceCard
                img={dir10}
                name="سعید بیات"
                job="رئیس اداره ارزیابی بازدید اولیه"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={dir4}
                name="آرمان عبدالهي"
                job="رئیس اداره دیجیتال واحد اموال "
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
              <HumanResourceCard
                img={dir5}
                name="مجتبی زیرک جو"
                job="رئیس اداره درامد و وصول"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
            <HumanResourceCard
                img={dir15}
                name="مرتضی طبیبی"
                job="رئیس اداره زنجیره تأمین"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
            <HumanResourceCard
                img={dir16}
                name="مهسا اسماعیل پور"
                job="رئیس اداره نجات"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
            <HumanResourceCard
                img={dir7}
                name="نیما امینی"
                job="رئیس اداره امداد خودرو"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
     
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
              <HumanResourceCard
                img={dir9}
                name="هلاله رحیم زاده"
                job="رئیس اداره CRM اشخاص"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
            <HumanResourceCard
                img={dir12}
                name="آرام عزیزی"
                job="رئیس اداره پشتیبان آنلاین بیمه‌های خودرو"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
            <HumanResourceCard
                img={dir14}
                name="اصغر نوری"
                job="رئیس اداره خسارت مالی خودروهای سنگین"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={10}>
              <HumanResourceCard
                img={dir2}
                name="نازنين حاجي نصرالله"
                job="رئیس اداره آموزش "
                phone=""
                mail=""
                size="tablet"
              />
            </Col>

            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>
            <Col span={10}>
           
            </Col>
            <Col span={10}>
            <HumanResourceCard
                img={dir13}
                name="محسن فراهانی"
                job="رئیس اداره خسارت مالی خودروهای سبک"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>

            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
     
    </div>
  ) : (
    <div>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={dir4}
            name="آرمان عبدالهي"
            job="رئیس اداره دیجیتال واحد اموال "
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      {/* <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={tmplady}
            name="ليدا هادي"
            job="سردبير رسانه مراقب بيمه"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row> */}
     
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={dir5}
            name="مجتبی زیرک جو"
            job="رئیس اداره درامد و وصول"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
    
     
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={dir7}
            name="نیما امینی"
            job="رئیس اداره امداد خودرو"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
     

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={dir9}
            name="هلاله رحیم زاده"
            job="رئیس اداره CRM اشخاص"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={dir2}
            name="نازنين حاجي نصرالله"
            job="رئیس اداره آموزش "
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <HumanResourceCard
            img={dir10}
            name="سعید بیات"
            job="رئیس اداره ارزیابی بازدید اولیه"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
        <HumanResourceCard
                img={dir12}
                name="آرام عزیزی"
                job="رئیس اداره پشتیبان آنلاین بیمه‌های خودرو"
                phone=""
                mail=""
              />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
        <HumanResourceCard
                img={dir13}
                name="محسن فراهانی"
                job="رئیس اداره خسارت مالی خودروهای سبک"
                phone=""
                mail=""
              />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
        <HumanResourceCard
                img={dir14}
                name="اصغر نوری"
                job="رئیس اداره خسارت مالی خودروهای سنگین"
                phone=""
                mail=""
              />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
        <HumanResourceCard
                img={dir15}
                name="مرتضی طبیبی"
                job="رئیس اداره زنجیره تأمین"
                phone=""
                mail=""
                size="mobile"
              />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
        <HumanResourceCard
                img={dir16}
                name="مهسا اسماعیل پور"
                job="رئیس اداره نجات"
                phone=""
                mail=""
                size="mobile"
              />
        </Col>
        <Col span={2}></Col>
      </Row>
     

     
    </div>
  );
};

export default HeadsTab;
